import * as React from 'react';

import './AuthenticationProviderButton.scss';

export interface AuthenticationProviderButtonProps {
  name: string;
  iconUrl: string;
  redirectUrl: string;
  'data-test'?: string;
}

/**
 * AuthenticationProviderButton component
 *
 * Displays button for authentication provider login
 */
export default class AuthenticationProviderButton extends React.PureComponent<AuthenticationProviderButtonProps> {
  render() {
    return (
      <a
        href={this.props.redirectUrl}
        className="authentication-provider-button"
        key={this.props.name}
        data-test={this.props['data-test']}
      >
        <img src={this.props.iconUrl} alt={this.props.name} />
        Sign in with {this.props.name}
      </a>
    );
  }
}
